export enum SmsMessageTemplateType {
	notify = 'Notify',
	alert = 'Alert',
}

export enum EmailMessageTemplateType {
	notify = 'Notify',
	deliver = 'Deliver',
	reminder = 'Reminder',
	frozen = 'Frozen',
	form = 'Form',
	alert = 'Alert',
	reject = 'Reject',
	cancel = 'Cancel',
}
